const DEFAULT_HOOKS = {
  onMessage: () => {},
  subscribe: () => {},
}

class CCPWebSocket {
  /**
   * @param url
   * @param hooks
   */
  constructor(url, hooks) {
    this.url = url
    this.hooks = { ...DEFAULT_HOOKS, ...hooks }
    this.webSocket = undefined
    this.wsTimer = undefined
    this.wsHeartbeat = undefined
    this.subscribers = []
    this.subscribe = (callback) => {
      this.subscribers.push(callback)
      return {
        unsubscribe: () => {
        this.subscribers = this.subscribers.filter(cb => cb !== callback)
      }}
    }
  }

  async init() {
    this.connect()
  }

  
  connect() {
    if (this.webSocket && this.webSocket.readyState !== WebSocket.CLOSED) {
      if (this.wsTimer) {
        clearInterval(this.wsTimer)
        this.wsTimer = undefined
      }
      return
    }
    this.webSocket = new WebSocket(this.url)
    this.webSocket.onopen = () => {
      this.webSocket.onmessage = event => {
        const message = JSON.parse(event.data)
        this.hooks.onMessage(message.event, message.data)
        this.subscribers.forEach(callback => callback?.(message.event, message.data))
      }
      this.wsHeartbeat = setInterval(() => {
        this.webSocket.send('{"action":"heartbeat"}')
      }, 10000)
    }
    this.webSocket.onerror = () => {
      this.webSocket.close()
      this.wsTimer = setInterval(() => {
        this.connect()
      }, 1000)
    }
    this.webSocket.onclose = () => {
      if (this.wsHeartbeat) {
        clearInterval(this.wsHeartbeat)
        this.wsHeartbeat = undefined
      }
      this.webSocket = undefined
    }
    this.subscribe = this.subscribe.bind(this)
  }
  
}

export default CCPWebSocket
